import React from 'react';
import WidgetEdit from '../components/WidgetEdit';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import qs from 'qs';

const WidgetEditPage = compose(
    connect(),
    lifecycle({
        componentWillReceiveProps() {},
        componentDidMount() {},
    }),
)(({ params }) => {
    // // loaded via router

    const query = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
        decoder: value => {
            value = decodeURIComponent(value);
            try {
                value = JSON.parse(value);
            } catch (e) {
                //
            }
            return value;
        },
    });

    return (
        <div>
            <WidgetEdit
                tab={params.tab}
                widgetId={params.widgetId}
                widgetProps={query}
                allowChangeWidget
                onChangeWidgetRequest={() => {
                    const { query } = browserHistory.getCurrentLocation();
                    browserHistory.push({
                        pathname: `/editor`,
                        query: { template: query.template },
                    });
                }}
            />

            <PageUrlObserver />
        </div>
    );
});

const PageUrlObserver = compose(
    connect(({ editor }) => ({
        widgetId: editor.widgetId,
        tab: editor.tab,
        widgetProps: editor.widgetProps,
    })),
    lifecycle({
        pushPropsToUrl: _.debounce((tab, widgetId, payload) => {
            if (!widgetId) return;
            const { query } = browserHistory.getCurrentLocation();

            const q = _.pickBy({ ...query, ...payload }, _.identity);
            const qq = _.chain(q)
                .toPairs(q)
                .map(([key, val]) => {
                    if (typeof val === 'object') {
                        return [key, JSON.stringify(val)];
                    } else {
                        return [key, val];
                    }
                })
                .fromPairs()
                .value();

            browserHistory.replace({
                pathname: `/editor/${widgetId}/${tab}`,
                query: qq,
            });
        }, 300),

        componentWillReceiveProps(nextProps) {
            const { widgetProps, widgetId, tab } = nextProps;
            this.pushPropsToUrl(tab, widgetId, widgetProps);
        },
        componentDidMount() {},
    }),
)(() => <div />);

export default WidgetEditPage;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/containers/WidgetEditPage.js
 **/